import { useLanguage as useLanguageContext } from '@/contexts/LanguageContext';

/**
 * Hook para acceder al contexto de idioma
 * Retorna el idioma actual, función para cambiarlo y función de traducción
 */
export function useLanguage() {
  return useLanguageContext();
}
